export default "__VITE_ASSET__ByyreHdg__"